document.addEventListener("DOMContentLoaded", function() {
    const divElements = document.querySelectorAll('.cart__dynamic-checkout-buttons div[role="button"], .cart__dynamic-checkout-buttons iframe');

    function enableElements() {
        divElements.forEach(function(divElement) {
            divElement.style.pointerEvents = 'auto';
            divElement.disabled = true;
        });
    }

    function disableElements() {
        divElements.forEach(function(divElement) {
            divElement.style.pointerEvents = 'none';
            divElement.disabled = false;
        });
    }

    document.body.addEventListener("click", function(event) {
        const termsCheckbox = document.getElementById("terms-and-conditions");
        const unfairCheckbox = document.getElementById("unfair-clauses");
        const checkoutButton = document.getElementById("checkout");

        if (termsCheckbox.checked && unfairCheckbox.checked) {
            const elements = document.getElementsByClassName('layer-container-buttons');
            for (let i = 0; i < elements.length; i++) {
                elements[i].classList.remove('blocked-checkout-layer');
            }
            checkoutButton.disabled = false;
            enableElements();
        } else {
            checkoutButton.disabled = true;

            const elementsLayerOpaco = document.getElementsByClassName('blocked-checkout-layer');
            if (elementsLayerOpaco.length < 2 || elementsLayerOpaco === undefined) {
                const elementsLayer = document.getElementsByClassName('layer-container-buttons');
                for (let i = 0; i < elementsLayer.length; i++) {
                    elementsLayer[i].classList.add('blocked-checkout-layer');
                }
            }

            enableElements();

            if (!termsCheckbox.checked) {
                termsCheckbox.setAttribute("aria-invalid", "true");
            }

            if (!unfairCheckbox.checked) {
                unfairCheckbox.setAttribute("aria-invalid", "true");
            }
        }
    });
});
